import React, { Component } from 'react'
import StagesManager from '../components/StagesManager';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import HttpServices from '../utils/Http.services';
import FileManager from './Drive/FileManager';
import { chooseFontColor } from '../utils/useful';
import FileSinglePage from './Drive/FileSinglePage';
// import Header from '../components/header/Header';
// import DriveToolbar from './Drive/DriveToolbar';
// import Notebook from './Notebook';
import { changeSelectedTextEffects, textEffectsList } from '../variables/notebook';
// import NotebookEditor from './NotebookEditor';
import DriveNoteEditor from './Drive/DriveNoteEditor';

class Drive extends Component {

    state = {
        applets: [],
        currentNote: {},
        page: {
            actions: [{ type: 'restore' }, { type: 'properties' }, { type: 'delete' }, { type: 'openFolder' }, { type: 'copy' }, { type: 'rename' }, { type: 'locked' }, { type: 'share' }, { type: 'starred' }, { type: 'trash' }]
        },
        extraBaseUrl: [],
        currentApplet: '',
        currentAppletHub: '',
        currentAppletName: 'All',
        appletSelected: false,
        headerConfig: {
            showToolbar: false, showSettings: false, showSettings: false, showFrames: false, isPortal: this.props.isPortal, title: this.props.isPortal && '{{lang}}Drive', type: 'drive',
        },
        showToolbar: false,
        // colors: {
        //     primaryColor: '#f58b00',
        //     secondaryColor: '#fd980b',
        //     textColor: '#fff'
        // },
        colors: {
            primaryColor: '#FFA01C',
            secondaryColor: '#F0C000',
            textColor: '#fff'
        },
        paths: [{ name: 'Drive', _id: null, link: null }],
        textEffectsList: [...textEffectsList],
        error: {},
    }

    componentDidMount() {
        let colors = this.state.colors
        if (this.props.colors) {
            colors = this.props.colors
        }
        else {
            colors = {
                primaryColor: '#FFA01C',
                secondaryColor: '#F0C000',
                textColor: '#fff'
            }
            // colors = {
            //     primaryColor: '#f58b00',
            //     secondaryColor: '#fd980b',
            //     textColor: '#fff'
            // }
            let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

            colors.iconInvert = iconInvert
            colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        }
        if (!this.props.isApplet && this.props.windowData.path[1]) {
            this.changeBaseUrl([this.props.windowData.path[1]])
        }
        this.setState({ colors }, () => {
            // this.init()
        })

        this.checkDefaultTab()
        // console.log('this.props.defaultHeaderConfig',this.props.defaultHeaderConfig)

    }

    componentDidUpdate(prevProps, prevState) {
        if ((JSON.stringify(this.props.data) != JSON.stringify(prevProps.data))) {
            // this.init()
        }
        if ((JSON.stringify(this.props.page) != JSON.stringify(prevProps.page))) {
            // console.log('change happend')
            // this.init()
        }
        if (JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path)) {
            this.checkDefaultTab()

            // this.changeStagePage('main')
        }

        if (JSON.stringify(this.props.baseUrl) != JSON.stringify(prevProps.baseUrl)) {
            this.checkDefaultTab()
        }
        // if (prevState.currentNote != this.state.currentNote && this.state.currentNote == null) {
        //     this.changeStagePage('main')
        // }
    }

    setHeader = (key, value, cb) => {
        // console.log("setHeader")
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    if (cb) {
                        cb()
                    }
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    // toolbarView = () => {
    //     return (
    //         <DriveToolbar permissions={this.props.permissions} isMobile={this.props.isMobile} functionsHandler={this.toolbarFunctionsHandler} colors={this.props.colors} language={this.props.language} width={this.props.width} addNewForm={this.props.addNewForm} currentFrame={this.state.currentFrame} list={this.state.list} editorId={this.state.editorId} />
    //     )
    // }


    checkDefaultTab() {
        let pathname = this.props.windowData.path

        let type = pathname[this.props.baseUrl.length]

        // console.log(type)
        // console.log(this.props.baseUrl)
        // console.log(this.props.windowData.path)



        if (this.stageManager) {
            switch (type) {

                case '':
                    this.stageManager.changeStage('main')
                    break;

                case 'folder':

                    this.stageManager.changeStage('main')
                    break;

                case 'file':
                    this.stageManager.changeStage('single')
                    break;

                case 'doc':

                    this.stageManager.changeStage('editor')

                    break;

                default:
                    this.stageManager.changeStage('main')
                    break;

            }

        }


    }

    toolbarFunctionsHandler = (type, name, data) => {
        if (this[name]) {
            this[name](data)
        }
    }

    changeAppletsTab = (item, index) => {
        this.setState({ currentApplet: item })
    }
    changeBaseUrl = (keys) => {
        let extraBaseUrl = keys
        this.setState({ extraBaseUrl })
    }
    init = () => {
        if (!this.props.isApplet) {

            this.getAppletsType()
        }
    }


    getAppletsType = () => {
        let { applets, currentApplet, currentAppletName, appletSelected } = this.state
        let path = this.props.windowData.path
        let error = {}
        // HttpServices.request('getMyFramesByType', { features: 'Drive' }, (fetchResult, fetchError) => {

        //     // console.log(fetchResult, fetchError)
        //     if (fetchError) {
        //         return
        //     }
        //     let promises = []
        //     for (let i = 0; i < fetchResult.info.length; i++) {
        //         promises.push(new Promise((resolve) => {
        //             if (fetchResult.info[i].applet.default) {
        //                 applets.push({ _id: fetchResult.info[i].applet._id, name: fetchResult.info[i].appletHub.fullname, icon: fetchResult.info[i].applet?.image, username: fetchResult.info[i].appletHub.username })
        //             }
        //             else {
        //                 applets.push({ _id: fetchResult.info[i].applet._id, name: fetchResult.info[i].applet.name, icon: fetchResult.info[i].applet?.image, username: fetchResult.info[i].appletHub.username })
        //             }
        //             resolve()
        //         }))
        //     }
        //     Promise.all(promises).then(() => {
        //         this.setState({ applets: applets }, () => {
        //             if (path[1]) {
        let found
        this.props.applets.forEach(el => {
            // console.log(el.applet._id, this.props.currentApplet?._id)
            if (el.applet._id == this.props.currentApplet?._id) {
                currentApplet = el._id;
                currentAppletName = el.name;
                appletSelected = true
                found = true
            }
        });
        if (!this.props.currentApplet) {
            found = true
        }

        if (!found) {
            error.applet = true
        }

        // console.log("found", found)

        // }
        // else {
        //     currentApplet = '';
        //     currentAppletName = 'All';
        //     appletSelected = false
        // }

        this.setState({ currentApplet, currentAppletName, appletSelected, error }, () => {
            this.stageManager.changeStage('main')
        })
        // })
        // })
        // })
    }

    changeWindowLink = (nPath, cb) => {
        if (this.props.isPortal) {
            let path = this.props.baseUrl
            path = [path[0]]
            if (nPath != null) {
                for (let i = 0; i < nPath.length; i++) {
                    if (nPath[i] != path[path.length - 1]) {
                        path.push(nPath[i])
                    }
                }
            }
            this.props.changeWindow('portal', { path: path })
            if (cb) {
                cb()
            }
        }
        else {
            this.props.changeWindowLink()
        }
    }

    changeStagePage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    setCurrentApplet = (key, value, cb) => {

        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'Drive') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    // getNote = (id) => {
    //     HttpServices.request("getNote", { _id: id }, (fetchResolve, fetchError) => {
    //         if (fetchError) { }
    //         let currentPage
    //         if (fetchResolve?.info?.content && fetchResolve?.info?.content[0]) {
    //             currentPage = fetchResolve?.info?.content[0]
    //         }
    //         this.setState({ note: fetchResolve?.info, currentPage }, () => {
    //             this.setState({ id, titleValue: this.state.note?.title, });
    //         });
    //     });
    // };

    updateTextEffectsStyleStatus = (activeStyles = []) => {
        const textEffectsList = [...this.state.textEffectsList];
        textEffectsList.forEach(textEffect => {
            const activeStyle = activeStyles.find(activeStyle => activeStyle === textEffect.styleName);
            if (activeStyle) {
                textEffect.isStyleActive = true
            } else {
                textEffect.isStyleActive = false

            }
        })
        this.setState({ textEffectsList })
    }

    titleValue = (e) => {
        this.setState({ titleValue: e.target.value }, () => { });
    }

    setName = (value, cb) => {
        this.setState({ noteTitle: value }, () => {
            if (cb)
                cb()
        });
    }

    backToFileManager = () => {
        this.setName('')
        let newLink = this.props.baseUrl.splice(2, 1)
        // newLink.push(item.link)
        let tmp = this.state.paths;
        let link = this.state.paths;
        // link.pop()
        if (!this.props.isApplet && this.state.currentApplet) {
            //TOCheck
            newLink.push(this.state.currentApplet)
        }
        // console.log('this.props.page', this.props.page)
        newLink.push(this.props.page._id)
        tmp = [...[link[link.length - 1]]]
        // let extraBaseUrl = tmp
        this.setState({
            paths: link,
            currentNote: null, noteData: null,
            // extraBaseUrl,
        },
            () => {
                // this.props.setData('paths', this.state.paths, 'DrivePortal')
                // let path = []
                tmp.forEach(el => {
                    if (el && el._id != null) {
                        // path.push(el._id)
                        // path = [el.link]
                        newLink.push(el.link)
                    }
                });
                this.props.changeWindowLink(newLink)
                setTimeout(() => {
                    this.changeStagePage('main')
                }, 250);
            })
    }

    changeNav = (type, id) => {

        let newLink = [type, id]
        if (type == 'root') {
            newLink = []
        }
        this.props.changeWindowLink(newLink)

    }


    render() {
        let colors = this.props.colors ?? (this.state.colors ?? {})
        // if (this.props.isPortal) {
        //     if (this.props.user.info?.colors) {
        //         colors = this.props.user.info.colors
        //     }

        //     if (!colors?.textColor) {
        //         colors.textColor = '#fff'
        //     }

        //     let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        //     colors.iconInvert = iconInvert
        //     colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        // }
        return (
            // <div className="w-100 d-flex Drive scroll-no-scrollbar h-100 window-content-radius"  >
            <div className=' bg-white w-100 d-flex flex-column window-content-radius h-100' >
                {/* <div style={{ position: 'relative', top: 0 }}>
                    <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changeStagePage={this.changeStagePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} />
                </div> */}
                <StagesManager ref={el => this.stageManager = el} height={'0px'} className={'flex-1'} fast={true}  >

                    <FileManager stageName='main' stage={1} db={this.state.db} windowData={this.props.windowData} height={'100%'} width={this.props.width}
                        applets={this.props.applets ?? this.state.applets} isPortal={this.props.isPortal}
                        changeAppletsTab={this.changeAppletsTab} language={this.props.language ?? this.props.settings.language}
                        adminView={true} isApplet={this.props.isApplet} currentApplet={this.props.currentApplet ?? this.state.currentApplet} applet={this.props.applet}
                        variables={this.props.variables}
                        goToHub={this.props.goToHub}
                        colors={this.state.colors}
                        changeWindowLink={this.props.changeWindowLink ?? this.changeWindowLink}
                        isDesktop={this.props.isDesktop}
                        isMobile={this.props.isMobile}
                        permissions={this.props.permissions}
                        // baseUrl={[...this.props.baseUrl, ...this.state.extraBaseUrl]} 
                        baseUrl={[...this.props.baseUrl]}
                        setCurrentFrame={this.props.setCurrentFrame}
                        lastSelected={this.props.lastSelected} changeWindow={this.props.changeWindow}
                        selectApplet={this.props.selectApplet}
                        initData={this.props.initData}
                        data={this.props.data}
                        error={this.state.error}
                        page={this.props.page}
                        setData={this.setData}
                        route={this.props.route}
                        setWindowInfo={this.props.setWindowInfo}
                        changeStagePage={this.changeStagePage}
                        changePage={this.props.changePage}
                        changeBaseUrl={this.changeBaseUrl}
                        setCurrentApplet={this.props.setCurrentApplet}
                        currentAppletName={this.state.currentAppletName}
                        appletSelected={this.state.appletSelected}
                        setHeader={this.props.setHeader}
                        paths={this.state.paths}
                        // getNote={this.getNote}
                        changeNav={this.changeNav}

                    />

                    <FileSinglePage stageName='single' stage={1} db={this.state.db} windowData={this.props.windowData} height={'100%'} width={this.props.width}
                        applets={this.props.applets ?? this.state.applets}
                        changeAppletsTab={this.changeAppletsTab} language={this.props.language ?? this.props.settings.language}
                        adminView={this.props.adminView} isApplet={this.props.isApplet} currentApplet={this.props.currentApplet} applet={this.props.applet} variables={this.props.variables} goToHub={this.props.goToHub}
                        colors={this.state.colors} changeWindowLink={this.props.changeWindowLink ?? this.changeWindowLink}
                        isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions}
                        lastSelected={this.props.lastSelected}
                        changeWindow={this.props.changeWindow}
                        selectApplet={this.props.selectApplet}
                        initData={this.props.initData}
                        data={this.props.data}
                        page={this.props.page}
                        setData={this.setData}
                        baseUrl={[...this.props.baseUrl]}
                        changeBaseUrl={this.changeBaseUrl}
                        route={this.props.route}
                        setWindowInfo={this.props.setWindowInfo}
                        changeStagePage={this.changeStagePage}
                        setHeader={this.props.setHeader}

                    />


                    <DriveNoteEditor
                        stage={1}
                        stageName={"editor"}
                        ref={el => this.notebookEditor = el}
                        currentPage={this.state.currentPage}
                        applet={this.props.applet ?? this.props.currentApplet ?? this.state.currentApplet}
                        changeSelectedTextEffects={(effectType, id) => changeSelectedTextEffects(effectType, id, this.updateTextEffectsStyleStatus)}
                        editorId={this.state.editorId}
                        changeStagePage={this.changeStagePage}
                        updateTextEffectsStyleStatus={this.updateTextEffectsStyleStatus}
                        textEffectsList={[...this.state.textEffectsList]}
                        language={this.props.language}
                        width={this.props.width}
                        setName={this.setName}
                        backToFileManager={this.backToFileManager}
                        noteTitle={this.state.noteTitle}
                        data={this.state.noteData}
                        setData={this.setData}
                        page={this.props.page}
                        note={this.state.note}
                        changeNotePage={this.changeNotePage}
                        titleValue={this.titleValue}
                        title={this.state.titleValue}
                        // createNote={this.createNote}
                        updateNote={this.updateNote}
                        isLoading={this.props.isLoading}

                        baseUrl={[...this.props.baseUrl, 'doc']}
                        changeWindowLink={this.props.changeWindowLink ?? this.changeWindowLink}
                        windowData={this.props.windowData}

                        setHeader={this.props.setHeader}
                        colors={colors}
                        isDesktop={this.props.isDesktop}
                        changeStage={this.changeStagePage}
                        appletType={'drive'}
                    />


                </StagesManager>
            </div>
            // </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Drive);
